import { withTranslation } from '../../../Translator';
import { SearchBar } from './SearchBar';

const TranslatedSearchBar = withTranslation('components')(SearchBar);

export { TranslatedSearchBar as SearchBar };
